import { images } from "../assets/img";

export const NAIL_SHOP_INFO = {
  ggMapUrl: "https://maps.app.goo.gl/bWPBVHDCRAokRkeW7",
  address: "166 High St, West Drayton UB7 7BE, United Kingdom",
  email: "linhpham95uk@gmail.com",
  tel: "+441895600639",
  phone: "+44 189 560 0639",
  facebook: "https://www.facebook.com/nailartyiewsley/",
  instagram: "https://www.instagram.com/nailart.yiewsley",
};

export const SERVICES = [
  {
    name: "Manicures",
    description:
      "We specialize in providing clients with professional nail treatments using only the finest brands and high-quality products. With over 600 colors available and special attention paid to your skin and cuticles, our treatments will leave your nails looking fantastic.",

    image: images.nailService,
  },
  {
    name: "Pedicures",
    description:
      "Nails And Toe Are Shaped, Smoothed And Cuticle Care, Exfoliation Cucumber/Peppermint Mask, Cream And Finish With Colour Of Your Choice.",
    image: images.nailService2,
  },
  {
    name: "Nails Extensions",
    description:
      "Enhance your nails with elegant extensions that blend style and durability. From natural looks to statement designs, our expert technicians craft each set with precision to reflect your unique beauty.",
    image: images.nailService3,
  },
  {
    name: "Nails Art",
    description:
      "From classic to outstanding, our talented technicians can advise you the bespoke nail art of your imagine. Come here and enjoy your amazing nails art at our local shop",
    image: images.nailService4,
  },
  {
    name: "Builder Gel",
    description:
      "Strengthen and perfect your natural nails with our premium builder gel. Ideal for adding length, durability, and a flawless finish, this treatment keeps your nails looking elegant and long-lasting.",
    image: images.nailService,
  },
];

export const LANGUAGE_ID = {
  vi: "vi",
  en: "en",
};
